<template>
  <div class="my-nexum-overlay">
    <transition name="nexum-fade">
      <div v-if="isOpen">
        <div class="nexum-overlay" @click.self="toggle()">
          <div class="error-box">
            <b-alert :show="isOpen" dismissible  variant="danger">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"> </i>
              {{error}}
            </b-alert>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>

  export default {
    props: ['isOpen', 'error'],
    methods: {
      toggle() {
        this.$store.commit('CHANGE_OVERLAY');
      },
    },
  };
</script>
<style lang="scss">
  .nexum-fade-enter-active,
  .nexum-fade-leave-active {
    transition: opacity .4s;
  }
  .nexum-fade-enter,
  .nexum-fade-leave-to {
    opacity: 0;
  }
  .my-nexum-overlay {
    position: absolute;
    z-index: 100;
  }

  .nexum-overlay {
    z-index: 99;
    position: fixed;
    top: 45vh;
    width: 60%;
    margin: 0 auto;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity .5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Overlay.vue